import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { resolveElements } from '../render/dom/utils/resolve-element.mjs';
import { visualElementStore } from '../render/store.mjs';
import { invariant } from '../utils/errors.mjs';
import { GroupPlaybackControls } from './GroupPlaybackControls.mjs';
import { isDOMKeyframes } from './utils/is-dom-keyframes.mjs';
import { animateTarget } from './interfaces/visual-element-target.mjs';
import { createVisualElement } from './utils/create-visual-element.mjs';
import { animateSingleValue } from './interfaces/single-value.mjs';
import { createAnimationsFromSequence } from './sequence/create.mjs';
import { isMotionValue } from '../value/utils/is-motion-value.mjs';

function animateElements(elementOrSelector, keyframes, options, scope) {
  var elements = resolveElements(elementOrSelector, scope);
  var numElements = elements.length;
  invariant(Boolean(numElements), "No valid element provided.");
  var animations = [];

  for (var i = 0; i < numElements; i++) {
    var element = elements[i];
    /**
     * Check each element for an associated VisualElement. If none exists,
     * we need to create one.
     */

    if (!visualElementStore.has(element)) {
      /**
       * TODO: We only need render-specific parts of the VisualElement.
       * With some additional work the size of the animate() function
       * could be reduced significantly.
       */
      createVisualElement(element);
    }

    var visualElement = visualElementStore.get(element);

    var transition = _objectSpread({}, options);
    /**
     * Resolve stagger function if provided.
     */


    if (typeof transition.delay === "function") {
      transition.delay = transition.delay(i, numElements);
    }

    animations.push.apply(animations, _toConsumableArray(animateTarget(visualElement, _objectSpread(_objectSpread({}, keyframes), {}, {
      transition: transition
    }), {})));
  }

  return new GroupPlaybackControls(animations);
}

var isSequence = function isSequence(value) {
  return Array.isArray(value) && Array.isArray(value[0]);
};

function animateSequence(sequence, options, scope) {
  var animations = [];
  var animationDefinitions = createAnimationsFromSequence(sequence, options, scope);
  animationDefinitions.forEach(function (_ref, subject) {
    var keyframes = _ref.keyframes,
        transition = _ref.transition;
    var animation;

    if (isMotionValue(subject)) {
      animation = animateSingleValue(subject, keyframes.default, transition.default);
    } else {
      animation = animateElements(subject, keyframes, transition);
    }

    animations.push(animation);
  });
  return new GroupPlaybackControls(animations);
}

var createScopedAnimate = function createScopedAnimate(scope) {
  /**
   * Implementation
   */
  function scopedAnimate(valueOrElementOrSequence, keyframes, options) {
    var animation;

    if (isSequence(valueOrElementOrSequence)) {
      animation = animateSequence(valueOrElementOrSequence, keyframes, scope);
    } else if (isDOMKeyframes(keyframes)) {
      animation = animateElements(valueOrElementOrSequence, keyframes, options, scope);
    } else {
      animation = animateSingleValue(valueOrElementOrSequence, keyframes, options);
    }

    if (scope) {
      scope.animations.push(animation);
    }

    return animation;
  }

  return scopedAnimate;
};

var animate = createScopedAnimate();
export { animate, createScopedAnimate };